import React, { useEffect } from 'react';
import { Keyboard, Animated, Easing } from 'react-native';
import PropTypes from 'prop-types';
import { noop } from 'Utils';
import Alert, { DEFAULT_BOTTOM, POP_OUT_DURATION } from '../../../Alert';

const TopKeyboardAlert = ({ style, message, onClose }) => {
    const bottom = new Animated.Value(0);

    const adjustAlertToKeyboard = (event) => {
        Animated.timing(bottom, {
            duration: event.duration,
            toValue: event.endCoordinates.height,
            useNativeDriver: false
        }).start();
    };

    useEffect(() => {
        const keyboardWillShowSub = Keyboard.addListener('keyboardWillShow', adjustAlertToKeyboard);
        const keyboardWillHideSub = Keyboard.addListener('keyboardWillHide', adjustAlertToKeyboard);

        return () => {
            keyboardWillShowSub.remove();
            keyboardWillHideSub.remove();
        };
    }, []);

    const alertPressed = () => {
        Animated.timing(bottom, {
            toValue: DEFAULT_BOTTOM,
            duration: POP_OUT_DURATION,
            easing: Easing.cubic,
            useNativeDriver: false
        }).start(onClose);
    };

    return (
        <Alert
            style={{ ...style, bottom }}
            message={message}
            icon="error_red"
            pop={false}
            onPress={alertPressed}
        />
    );
};

TopKeyboardAlert.defaultProps = {
    style: {},
    message: '',
    onClose: noop
};

TopKeyboardAlert.propTypes = {
    style: PropTypes.shape({}),
    message: PropTypes.string,
    onClose: PropTypes.func
};

export { TopKeyboardAlert };
